import React, { useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from "@material-ui/core/Checkbox";
import { Typography } from "@material-ui/core";
import { Container } from "@material-ui/core";
import { FormContext } from "../../util/context";
import { Button } from "@material-ui/core";
import { Grid } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: 360,
  },
}));

export default function Category() {
  const [form, setForm] = useContext(FormContext);
  const classes = useStyles();

  const handleToggle = (value) => () => {
    const currentIndex2 = form.professionArray.indexOf(value);
    const newChecked2 = [...form.professionArray];

    if (currentIndex2 === -1) {
      newChecked2.push(value);
    } else {
      newChecked2.splice(currentIndex2, 1);
    }

    setForm({ ...form, professionArray: newChecked2 });
    console.log(form.professionArray);
  };
  const onNext = () => {
    setForm({
      ...form,
      count: form.count + 1,
    });

    console.log(form.professionArray);
  };
  return (
    <>
      <Container maxWidth="sm">
        <Typography align="center" variant="h4">
          Which group(s) best describes you, past and present? Check all that
          apply.
        </Typography>
      </Container>
      <List className={classes.root}>
        {[
          "Military Personnel",
          "Athlete",
          "White-Collar Worker",
          "Blue-Collar Worker",
          "Retired",
        ].map((value) => {
          const labelId = `checkbox-list-label-${value}`;

          return (
            <ListItem
              key={value}
              role={undefined}
              dense
              button
              onClick={handleToggle(value)}
            >
              <ListItemIcon>
                <Checkbox
                  edge="start"
                  checked={form.professionArray.indexOf(value) !== -1}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{ "aria-labelledby": labelId }}
                />
              </ListItemIcon>
              <ListItemText
                id={labelId}
                disableTypography
                primary={<Typography variant="h6">{value}</Typography>}
              />
            </ListItem>
          );
        })}
      </List>
      <Grid container={true} spacing={2}>
        <Grid item={true} xs={12}>
          <Button
            variant="contained"
            fullWidth
            color="primary"
            onClick={onNext}
          >
            Next
          </Button>
        </Grid>
      </Grid>
    </>
  );
}
